import styled from '@emotion/styled'
import { css } from '@emotion/react'

const menuStyles = ({ theme }) => css`
  label: menu;

  display: flex;
  flex-wrap: wrap;

  border-bottom: 1px solid ${theme.colors.n100};
  padding-bottom: ${theme.spacings.mega};
  margin-bottom: ${theme.spacings.mega};

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }
`

const subMenuStyles = ({ theme }) => css`
  label: menu__submenu;

  padding-top: ${theme.spacings.kilo};
  padding-left: ${theme.spacings.tera};
  flex-basis: 100%;

  a {
    margin-bottom: ${theme.spacings.byte};
  }
`

const menuItemStyles = ({ theme }) => css`
  label: menu__item;

  display: flex;
  align-items: center;

  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  line-height: ${theme.typography.subHeadings.kilo.lineHeight};
  font-weight: ${theme.font.weight.regular};
  color: ${theme.colors.n400};

  transition: color ${theme.transition.leave} ease-in-out;

  &:hover {
    color: ${theme.colors.p500};
  }
`

const activeMenuStyles = ({ isActive, theme }) =>
  isActive &&
  css`
    label: menu__item--active;

    font-weight: ${theme.font.weight.semibold};
    color: ${theme.colors.n600};
  `

const glyphStyles = ({ theme }) => css`
  label: menu__glyph;

  font-size: ${theme.typography.subHeadings.mega.fontSize};
  margin-right: ${theme.spacings.kilo};
`

export const Menu = styled('div')(menuStyles)
export const Submenu = styled('nav')(subMenuStyles)
export const MenuItem = styled('a')(menuItemStyles, activeMenuStyles)
export const Glyph = styled('i')(glyphStyles)
